import { z } from 'zod'
import { zLocale } from '../../i18n'
import {
  zAnnotationArea,
  zAnnotationDifferenceLine,
  zAnnotationHorizontalLine,
  zAnnotationPoint,
  zAnnotationVerticalLine,
  zBackgroundColor,
  zBarMaxWidth,
  zBarStyle,
  zColor,
  zCrosshairRect,
  zDataset,
  zDimensionLinkage,
  zDimensions,
  zEncoding,
  zLabel,
  zLegend,
  zMeasures,
  zPolynomialRegressionLine,
  zRegionPadding,
  zSort,
  zSortLegend,
  zCornerRadius,
  zStackCornerRadius,
  zTheme,
  zTooltip,
  zBrush,
  zXBandAxis,
  zYLinearAxis,
  zPage,
  zPlayer,
  zBarLikeAnimation,
} from '../../properties'

export const zColumn = z.object({
  chartType: z.literal('column'),
  dataset: zDataset.nullish(),
  encoding: zEncoding.nullish(),
  dimensions: zDimensions.nullish(),
  measures: zMeasures.nullish(),
  page: zPage.nullish(),
  player: zPlayer.nullish(),

  backgroundColor: zBackgroundColor.nullish(),
  color: zColor.nullish(),
  label: zLabel.nullish(),
  legend: zLegend.nullish(),
  regionPadding: zRegionPadding.nullish(),
  tooltip: zTooltip.nullish(),
  brush: zBrush.nullish(),
  animation: zBarLikeAnimation.nullish(),
  xAxis: zXBandAxis.nullish(),
  yAxis: zYLinearAxis.nullish(),
  sort: zSort.nullish(),
  sortLegent: zSortLegend.nullish(),
  crosshairRect: zCrosshairRect.nullish(),
  cornerRadius: zCornerRadius.nullish(),
  stackCornerRadius: zStackCornerRadius.nullish(),
  barMaxWidth: zBarMaxWidth.nullish(),
  theme: zTheme.nullish(),
  barStyle: z.array(zBarStyle).or(zBarStyle).nullish(),
  annotationPoint: z.array(zAnnotationPoint).or(zAnnotationPoint).nullish(),
  annotationVerticalLine: z.array(zAnnotationVerticalLine).or(zAnnotationVerticalLine).nullish(),
  annotationHorizontalLine: z.array(zAnnotationHorizontalLine).or(zAnnotationHorizontalLine).nullish(),
  annotationArea: z.array(zAnnotationArea).or(zAnnotationArea).nullish(),
  annotationDifferenceLine: z.array(zAnnotationDifferenceLine).or(zAnnotationDifferenceLine).nullish(),
  polynomialRegressionLine: z.array(zPolynomialRegressionLine).or(zPolynomialRegressionLine).nullish(),
  dimensionLinkage: zDimensionLinkage.nullish(),
  locale: zLocale.nullish(),
})
